/**
 * `[allegato: <attachmentId> <filename> nota:<caption>]`: how a staged upload
 * travels inside a user message. The `nota:` segment is optional and carries
 * the human caption of the interview field the photo was attached for. Built
 * by the assistant composer and panel, read by the chat bubble (chip) and by
 * the backend (tool resolution, PDF caption): one format, one parser.
 */

export const ATTACHMENT_MARKER_PATTERN = /\[allegato:\s*([^\]]+)\]/g;

export interface AttachmentMarker {
  attachmentId: string;
  filename: string;
  caption: string | null;
}

export function buildAttachmentMarker(marker: {
  attachmentId: string;
  filename: string;
  fieldCaption?: string | null;
}): string {
  const captionSuffix = marker.fieldCaption ? ` nota:${marker.fieldCaption}` : '';
  return `[allegato: ${marker.attachmentId} ${marker.filename}${captionSuffix}]`;
}

/** Parses what sits between `[allegato:` and `]`; `null` when there is no filename. */
export function parseAttachmentMarkerPayload(payload: string): AttachmentMarker | null {
  const match = /^\s*(\S+)\s+(.+?)(?:\s+nota:(.+?))?\s*$/s.exec(payload);
  if (!match) {
    return null;
  }
  return { attachmentId: match[1], filename: match[2], caption: match[3] ?? null };
}
